/* eslint-disable no-unused-vars */
import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useLayoutEffect,
  useRef,
} from 'react';
import ContextProviders from '@/contexts/ContextProviders';
import { useLocation, useSelector } from 'umi';
// import { useDispatch } from 'dva';
import { themes as brandThemes } from '@/theme/themes';
import buildTheme from '@/theme-mui/index';
import AlertTip from '@/components/AlertML';
import TopBar from './TopBar';
import NavBar from './NavBar';

import BreadcrumbsBar from './BreadcrumbsBar';
// import BrandSelect from '../pages/brand/brandselect';
import webStorage from '@/utils/storageManager';
import { brandCodeMap, LANG_MAP } from '@/constants';

import { LayoutsStyled } from './LayoutsStyled';

const Layouts = (props) => {
  // const dispatch = useDispatch();

  const muiTheme = buildTheme();

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [toastParameter, setToastParameter] = useState({});
  const drawerWidth = isMobileNavOpen ? 0 : 256;

  // const [language, setlanguage] = useState(
  //   webStorage.get('LANG') || LANG_MAP.default,
  // );
  const language = webStorage.get('LANG');

  // const [isOutContent, setIsOutContent] = useState(true);
  const [contentInnerHeight, setContentInnerHeight] = useState(0);
  const loadingGlobal = useSelector((state) => state.loading.global);

  window.message = {
    toast: ({ timeout = 3000, message = '', title, type = 'success' }) => {
      setToastParameter({
        open: true,
        type,
        timeout,
        message,
        title,
        handleClose: () => {
          setToastParameter({
            open: false,
            type,
            timeout,
            message,
            title,
          });
        },
      });
    },
  };
  const [brand, setBrand] = useState(
    webStorage.get('BRAND_CODE') || brandCodeMap.default,
  );
  // console.log('💢felix => Layouts => brand', brand);

  //登陆页面显示情况
  const location = useLocation();
  const { pathname, search } = location;
  const isContentPage =
    !pathname.includes('/login') && !pathname.includes('/brand');
  const noInnerWapperPage =
    pathname.includes('/ec/') ||
    (pathname.includes('/report/') &&
      !pathname.includes('/report/member-data') &&
      !pathname.includes('/report/vip_data') &&
      !pathname.includes('/report/StoreMemberAnalysis')) ||
    pathname.includes('/login');
  const isCombatReport =
    pathname.includes('/report/cs') || pathname.includes('/report/store_list');

  useLayoutEffect(() => {
    if (isCombatReport) {
      document.querySelector('#root').style.overflow = 'auto';
    }
    return () => {
      document.querySelector('#root').style.overflow = 'hidden';
    };
  }, [isCombatReport]);
  //是否为品牌选择页面
  // const isBrandSelect = pathName.includes('/brand');

  // 品牌切换事件
  // const handleBrandChange = (seledBrand) => {
  //   console.log('handleBrandChange -> seledBrand', seledBrand);
  //   const brandId = seledBrand.split(':')[0];
  //   const brandCode = seledBrand.split(':')[1];
  //   setBrand(brandCode);
  //   webStorage.set('BRAND_ID', brandId);
  //   webStorage.set('BRAND_CODE', brandCode);
  //   // 重新调用字典接口
  //   dispatch({
  //     type: 'common/getDictAll',
  //     payload: {},
  //     callback: (res) => {
  //       let type = [];
  //       let result = {};
  //       res &&
  //         res.forEach((item) => {
  //           if (type.indexOf(item.dictType) === -1) {
  //             type.push(item.dictType);
  //           }
  //         });
  //       type &&
  //         type.forEach((item) => {
  //           result[item] = [];
  //           res.forEach((item2) => {
  //             if (item === item2.dictType) {
  //               result[item].push(item2);
  //             }
  //           });
  //         });
  //       // webStorage.set('DICTALL', res);
  //       webStorage.set('DICTOBJ', result);
  //     },
  //   });
  // };

  const contentRef = useRef();
  const contentInnerRef = useRef();

  // 页面resize事件
  const handleWinResize = useCallback(() => {
    // 主内容区域中的容器盒子的内容实际高度
    const contentInnerOriginHeight =
      contentInnerRef?.current?.scrollHeight + 60;
    setContentInnerHeight(contentInnerOriginHeight);
    // // 主内容区域的可见高度
    // const contentHeight = contentRef?.current?.clientHeight;
    // // 内容超出了可见高度
    // setIsOutContent(contentInnerOriginHeight >= contentHeight);
  }, []);

  // 只有路由发生变化时回到顶部
  useEffect(() => {
    if (contentRef?.current?.scrollTop > 0) {
      contentRef.current.scrollTop = 0;
    }
  }, [pathname]);

  // 添加resize监听
  useEffect(() => {
    window.addEventListener('resize', handleWinResize);
    return () => {
      window.removeEventListener('resize', handleWinResize);
    };
  }, [handleWinResize]);

  // 当路由和路由参数发生变化时触发resize事件
  useEffect(() => {
    // console.log('💢felix => path change', pathname, search);
    !loadingGlobal && handleWinResize();
  }, [handleWinResize, pathname, search, loadingGlobal]);

  // console.log('💢felix => Layouts => isOutContent', isOutContent);

  return (
    <ContextProviders
      brand={brand}
      brandThemes={brandThemes}
      muiTheme={muiTheme}
      language={language}
    >
      <LayoutsStyled
        brand={brand}
        brandThemes={brandThemes}
        theme={muiTheme}
        drawerWidth={drawerWidth}
        contentInnerHeight={contentInnerHeight}
        // isOutContent={isOutContent}
        isContentPage={isContentPage}
      >
        {isContentPage && !isCombatReport && (
          <>
            <TopBar
              className="header"
              onMobileNavOpen={() => setMobileNavOpen(true)}
            />
            <NavBar
              onMobileClose={() => setMobileNavOpen(false)}
              openMobile={isMobileNavOpen}
            />
          </>
        )}
        {isCombatReport ? (
          props.children
        ) : (
          <main className="content" ref={contentRef}>
            {isContentPage && <BreadcrumbsBar className="breadbar" />}
            {noInnerWapperPage ? (
              props.children
            ) : (
              <div
                className="content-inner-wapper"
                ref={contentInnerRef}
                // style={{
                //   height: 'calc(100vh - 56px)',
                //   display: 'flex',
                //   flexDirection: 'column',
                //   padding: '12px',
                // }}
              >
                {props.children}
              </div>
            )}
            <AlertTip parameter={toastParameter} />
          </main>
        )}
      </LayoutsStyled>
    </ContextProviders>
  );
};

export default Layouts;
